import React from 'react'

import { Div, Divider, Text } from '@vividseats/vivid-ui-kit'

import styles from './styles.module.scss'

interface Props {
    withDivider?: boolean
}

const NoNearbyListings: React.FC<Props> = ({ withDivider = true }) => {
    return (
        <>
            <Div paddingLeft={5} paddingRight={5} data-testid="no-nearby-listings" className={styles.fallbackMessage}>
                <Text size="lg" altFont>
                    There are no upcoming events near you.
                </Text>
            </Div>
            {!!withDivider && <Divider data-testid="no-nearby-listings-divider" />}
        </>
    )
}

export default NoNearbyListings
